import { ArtworkMockupModel } from "./ArtworkMockupModel";
import { LogoMockupModel } from "./LogoMockupModel";

export class OrderTagMockupModel {
    constructor() {
        this.logoMockupModel = new LogoMockupModel();
        this.artworkMockupModels = [new ArtworkMockupModel()];
    }
}
